<template>
    <div class="notify-card text-left">
        <div class="row">
            <div class="col-sm-12 col-md-8">
                <div class="notify-card-content">
                    <h5><b>Learn skills and get ahead</b></h5>
                </div>
                <div class="supporting-text-notify">Learn Front-end technologies (React, Angular), Mobile technologies (React Native, Android), and UI/UX Design</div>
            </div>
            <div class="col-sm-8 col-md-4">
                <img src="@/assets/laptop_skin_much_smaller_skills.svg" alt="product challenges" id="header-graphic">
                         
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotifyCard'
}
</script>


<style>
    .notify-card {
		width:100%;
        height:100%;
        box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
        background-color: #fff;
        padding:20px;
        margin-top:0px;   
        border-radius: 10px; 
        font-family: Avenir;                        
	}

    .supporting-text-notify {
        margin-top:2%; 
        margin-left:4%; 
        margin-right:4%;
        color:#000;
        font-size:14px;
        width:84%;
        margin-bottom:0%;
    }

    @media (min-width:760px) {
        .notify-card {
            width:100%;
            height:100%;
            box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
            transition: all 0.3s ease;
            background-color: #fff;
            margin-top:0px;   
            border-radius: 10px; 
            font-family: Avenir;                        
        }

        .notify-card-content { 
            margin-left:4%; 
            margin-right:4%;
            color:#000;
            font-size:14px;
            width:100%;
            padding-top:4%;
        }

        .supporting-text {
            margin-top:2%; 
            margin-left:4%; 
            margin-right:4%;
            color:#000;
            font-size:14px;
            width:84%;
            margin-bottom:0%;
        }
    }

    .notify-card-content {
        margin-left:4%; 
        margin-right:4%;
        color:#000;
        font-size:14px;
        width:84%;
    }

    @media (max-width:760px) {
        #header-graphic {
            width:100%;
            height:20%;
            margin-top: 4%;
            margin-bottom:24%;
            display: none;
        }

        .notify-card-content {
            margin-top:0%; 
            margin-left:4%; 
            margin-right:4%;
            color:#000;
            font-size:14px;
            width:84%;
            margin-bottom:0%;
        }

        .notify-card {
            display: none;
        }
    }

    #header-graphic {
        width:100%;
        height:100%;
    }

</style>



